import { render } from "./ReturnChannel.vue?vue&type=template&id=1f393356&scoped=true"
import script from "./ReturnChannel.vue?vue&type=script&lang=js"
export * from "./ReturnChannel.vue?vue&type=script&lang=js"

import "./ReturnChannel.vue?vue&type=style&index=0&id=1f393356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f393356"]])

export default __exports__